module.exports = __webpack_public_path__ + "static/media/theta.68fdc159.svg";